import {id} from './id'
import {model} from './model'
import {enumerator} from './enum'
import {arrayOf} from './array'
import * as tags from './tags'
import * as primitives from './primitives'
import * as time from './time'
import * as bytes from './bytes'
import * as hash from './hash'
import * as network from './network'
import {any} from './any'

const schemerTypes = {
  id,
  model,
  enum: enumerator,

  any, // Generic/custom type, with no assumptions made about display formatting or input.
  
  arrayOf, // Special wrapper that accepts a type decorator as lone argument. See README for usage

  ...tags,
  
  ...primitives,
  ...time,
  ...bytes,
  ...hash,
  ...network
}

export default schemerTypes